import { useTranslation } from 'react-i18next';

import QuestionFill from '@/assets/icons/question_fill.svg?component';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import DropDownPanel from '@/components/molecules/DropDownPanel';

import ViewerHelpTextBlocks from './ViewerHelpTextBlocks';

import styles from './HelpDropdown.module.scss';

const HELP_BUTTON_NAME = 'help';

export default function HelpDropdown() {
    const { t } = useTranslation();

    return (
        <DropDownPanel
            label={t('organisms.imageViewer.showHelpText')}
            variant="toolbar"
            name={HELP_BUTTON_NAME}
            icon={<SvgIcon color="currentColor" icon={QuestionFill} />}
            className={styles.panel}>
            <ViewerHelpTextBlocks />
        </DropDownPanel>
    );
}
